__turbopack_context__.v({
  "backgroundImage": "CTASection-module-scss-module__ywu4ra__backgroundImage",
  "backgroundPatterns": "CTASection-module-scss-module__ywu4ra__backgroundPatterns",
  "backgroundPatternsMobile": "CTASection-module-scss-module__ywu4ra__backgroundPatternsMobile",
  "buttonLink": "CTASection-module-scss-module__ywu4ra__buttonLink",
  "containerWrapper": "CTASection-module-scss-module__ywu4ra__containerWrapper",
  "dividerLine": "CTASection-module-scss-module__ywu4ra__dividerLine",
  "fadeOverlay": "CTASection-module-scss-module__ywu4ra__fadeOverlay",
  "root": "CTASection-module-scss-module__ywu4ra__root",
});
